import React from "react";

export default function ProgressBar({ completed, total }) {
  const percentage = Math.round((completed / total) * 100);

  return (
    <div>
      <div
        style={{
          background: "var(--bg-color, #fff)",
          borderRadius: 99,
          height: 12,
          marginBottom: 8,
          overflow: "hidden",
          border: "1px solid var(--border-color, #E5E7EB)",
        }}
      >
        <div
          style={{
            background: "linear-gradient(90deg, #10B981, #0EA5E9)",
            height: "100%",
            width: `${percentage}%`,
            borderRadius: 99,
            transition: "width 0.4s ease",
          }}
        />
      </div>
      <p
        style={{
          fontSize: 13,
          color: "var(--text-color-secondary, #6B7280)",
          textAlign: "right",
          marginBottom: 28,
        }}
      >
        {completed}/{total} completados · {percentage}%
      </p>
    </div>
  );
}
